import { useMutation } from '@apollo/client'
import { EditResultEventSample, EditResultEventSampleVariables } from '../../types'
import { EDIT_RESULT_EVENT_SAMPLE } from './operations'

export const useEditResultEventSample = () =>
  useMutation<EditResultEventSample, EditResultEventSampleVariables>(EDIT_RESULT_EVENT_SAMPLE)
